import axios from "axios";
import { apis, serverCall } from "../../utils/api/constant";
import { setDataOtherCharges, setDataElectricityCharges, setDataNewTariff, uploadDataNewTariff } from "./action";
import { logOut } from "../../Logout";
// Thunk action creator
export const setNewTariff = (data) => {
  return async (dispatch, getState) => {
    dispatch(setDataNewTariff(data));
  };
};

export const setElectricityCharges = (data) => {
  return async (dispatch, getState) => {
    dispatch(setDataElectricityCharges(data));
  };
};

export const setOtherCharges = (data) => {
  return async (dispatch, getState) => {
    dispatch(setDataOtherCharges(data));
  };
};


export const uploadNewTariff = (userData) => {
  return async (dispatch, getState) => {
    try {
      let response = await serverCall(apis.UPLOAD_NEWTARIFF_DATA, "POST", { "apiID": userData?.id ? 1 : 0, "userName": userData?.data?.pDATASET[0]?.USERNAME, "data": userData?.masterValue }, { "sid": userData?.data?.token });
      if (response?.data?.ERROR_STATUS === true) {
        console.log(response.data)
        logOut(response.data); // Run logout function only on error
      }
      if (response.success) {
        dispatch(uploadDataNewTariff(response.data));
      } else {
        dispatch(uploadDataNewTariff(response.data));
      }
    } catch (error) {
    }
  };
};
